import React from 'react';

export default function NotesStep({ data, update }) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/80 mb-1">Notes</label>
      <p className="text-xs text-white/40 mb-2">
        Write anything — triggers, what you ate, how you slept, context about your day. This feeds into your AI insights.
      </p>
      <textarea
        value={data.notes || ''}
        onChange={(e) => update({ notes: e.target.value })}
        placeholder="e.g. Had gluten at lunch, didn't sleep well, felt off all morning, tried a new supplement..."
        rows={5}
        className="w-full rounded-lg bg-white/10 border-white/20 text-white placeholder-white/40 shadow-sm focus:border-white/40 focus:ring-white/30"
      />
    </div>
  );
}
